import { createSelector } from "@reduxjs/toolkit";
import { DocumentReducer } from "./documentSlice";

const selectAll = (state: DocumentReducer) => state.document;

const allDocuments = (state: DocumentReducer) => selectAll(state).allDocuments;

/**
 * The applicant's resume, if one has been uploaded. Matched on document type
 * rather than the old `criterion` taxonomy field, which no longer exists.
 */
const resumeDocument = createSelector([allDocuments], (docs) =>
  docs.find(
    (document) =>
      !document.isDeleted &&
      typeof document.type === "string" &&
      document.type.toLowerCase().includes("resume")
  )
);

const extractedData = (state: DocumentReducer) =>
  selectAll(state).extractedData;
const isLoadingDocuments = (state: DocumentReducer) =>
  selectAll(state).isLoadingDocuments;
const isUploadingDocuments = (state: DocumentReducer) =>
  selectAll(state).isUploadingDocuments;
const corruptRemovedNames = (state: DocumentReducer) =>
  selectAll(state).corruptRemovedNames || [];

export const documentSelectors = {
  selectAll,
  allDocuments,
  resumeDocument,
  extractedData,
  isLoadingDocuments,
  isUploadingDocuments,
  corruptRemovedNames
};
